import { useLocation, useNavigate, useParams, useRoutes } from "react-router-dom";
import routes from "routes/routes";
import Header from "components/Header";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import Sidebar from "components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { PERMISSION_KEY, LOGOUT_TIME_MIN } from "../constants/index";
import Users from "pages/users";
import AddUpdateUser from "pages/users/addUpdate";
import RoleManagement from "pages/role-management";
import AddRole from "pages/role-management/addRole";
import Group from "pages/group"
import AddUpdateGroup from "pages/group/addUpdate";
import Notification from "pages/notification";
import Dashboard from "pages/dash-board";
import FlagSettings from "pages/flag-setting";
import DocumentApproval from "pages/document-approval";
import Permission from "pages/permission";
import DocumentProcessing from "pages/document-processing";
import { deleteConversation, getConversationsList, getLanguage, getUploadedDoc, logout } from "services/coversationService";
import { toast, ToastContent } from "react-toastify";
import { conversationDeleted, handleChatclose, handleDocuMateCounter, handleDocuMatePDF, handleDocuMateUserQuery, handleLoader, handleQMateCounter, setHistoryCalled, setStopId } from "redux/counterSlice";
import VoiceInteraction from "pages/voice-interaction/VoiceInteraction"
import AiChatbot from "pages/ai-chat-bot"
import ParamConfiguration from "pages/configuration";
import BotConfiguration from "pages/bot-configurations";
import BlackListedWords from "components/voice-interaction/BlackListedWords";
import AddBlackListWord from "components/voice-interaction/AddBlackListedWordPage";
import WebScrapper from "pages/web-scrapper/WebScrapper";
import History from "pages/web-scrapper/History";
import ProcessImage from "pages/process-image";
import PdfUpload from "pages/pdf-upload";
import FileConfig from "pages/file-config";
import { handleActive, handleAnnouncementPermission, handleGroupPermission, handleRolePermission, handleUserPermission, resetQuestion } from "redux/persistentSlice";
import HeaderOne from "components/HeaderOne";
import VoiceHistory from "pages/voice-interaction/VoiceHistory";
import { deleteCoversation } from "services/lensService";
import Home from "pages/home";
import { chatBotWhite } from "assets/icons";
import ImageExpansion from "pages/image-expansion";
import SmartBackground from "pages/smart-background";
import GenerateInstance from "pages/generate-instance";
import CompareImage from "components/compare-image/CompareImage";
import GenerateArtical from "pages/generate-artical";
import GenerateEmail from "pages/generate-email";
import GenerateIdea from "pages/generate-idea";
import GeneratePost from "pages/generate-post";
import GenerateProduct from "pages/generate-product";
import InventoryForecastConfiguration from "pages/inventory-forecast-configuration";
import SentimentAnalysis from "pages/generate-sentiment-analysis";
import ConversationHistory from "pages/conversation-history";
import UserDashboard from "pages/user-dashboard";
import { Button } from "primereact/button";
import ConversationList from "components/ai-chat-board/ConversationList";
import * as myconst from '../constants/index'
import moment from "moment";
import StateContext from "constants/StateContext";
import Modal from "pages/modal";

interface deleteCoversationType {
    client_env: string | null,
    user_name: string | null,
    conv_id: string | null,
    source_name: string | null,
}
interface flag_type {
    [key: string]: boolean; // Allows indexing with strings
};
interface conversation_type {
    conversation_id: string,
    title: string,
    created_at: string,
    update_time: string
}

interface data_type_history {
    [key: string]: conversation_type[]
}
interface show_edit_delete_type {
    [key: string]: boolean
}
interface delete_confirmation_type {
    date: string,
    index: number
}
interface Query {
    que: string;
    isUser: boolean;
}

interface source_info_type {
    link: string,
    name: string,
}

interface Answer {
    ans: {
        isFirst?: boolean;
        response: {
            output_text: string,
        },
        id: string,
        rating?: string,
        created_time: string,
        feedback: string,
        source_info: source_info_type[],
        csv_file: string,
        file_flag: boolean,
        file_type: string,
        response_time: string,
    },
}

const Baselayout = () => {
    const params = useParams();
    const promptText = "This chat will be deleted, along with all related activity, including prompts, responses, and feedback from your RysunAI activity."
    const [menuToggle, setMenuToggle] = useState((window.innerWidth >= 768 && window.innerWidth <= 991) ? true : false);
    const [isActive, setActive] = useState<boolean>(false);
    let tempRoutes = routes;
    const overlayLens: any = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation()
    const oh: any = useRef(null);
    const temp = location.pathname.split('/').filter(entry => entry.trim() !== '');
    const currentActive = useSelector((state: any) => state.persistent.currentActive);
    // const [element, setElement] = useState([]);
    const sidebarRef: any = useRef(null);
    const logoRef: any = useRef(null);
    const loader = useSelector((state: any) => state.counter.loader);
    const docuMateLan = useSelector((state: any) => state.counter.docuMateLan);
    const chatBotPreview = useSelector((state: any) => state.counter.chatBotPreview);
    const notFound = useSelector((state: any) => state.counter.notFound);
    const permissionStr: any = localStorage.getItem("permissions")
    let featureHistory: flag_type = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const HistoryFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.history]
    const [current, setCurrent] = useState<null | string>(null);
    const [data, setData] = useState<data_type_history>();
    const [visibleRight, setVisibleRight] = useState<boolean>(false);
    const [hover, setHover] = useState<null | string>(null);
    const [showEditDelete, setShowEditDelete] = useState<show_edit_delete_type>({});
    const [isDeleteClicked, setIsDeleteClicked] = useState<(boolean | undefined)[]>([]);
    const [delId, setDelId] = useState<string>('');
    const [deleteConfirmation, setDeleteConfirmation] = useState<delete_confirmation_type>({
        date: '',
        index: NaN,
    });
    const [paramsId, setParamsId] = useState<string>('');
    const [userQuery, setUserQuery] = useState<Query[]>([]);
    const [answer, setAnswer] = useState<Answer[]>([]);
    const [base64, setBase64] = useState<string>("");
    const [inputfilename, setInputFileName] = useState("");
    const [modalOption, setModalOption] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [comparisonDocFile, setComparisonDocFile] = useState("");
    const [synthesizeDocFile, setSynthesizeDocFile] = useState("");
    const [comparisonDocName, setComparisonDocName] = useState("");
    const [synthesizeDocName, setSynthesizeDocName] = useState("");
    const [modalOptionCompare, setModalOptionCompare] = useState("")
    const [modalOptionSynthesize, setModalOptionSynthesize] = useState("")
    const [showShare, setShowShare] = useState<boolean>(false);
    const [showModalCompare, setShowModalCompare] = useState(false)
    const [showModalSynthesize, setShowModalSynthesize] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [emailData, setEmailData] = useState({});
    const [fileLanguage, setFileLanguage] = useState("");
    const [fileCompLanguage, setFileCompLanguage] = useState("");
    const [fileSynthLanguage, setFileSynthLanguage] = useState("");
    /*
    Get local storage details

    */
    const accessToken: any = localStorage.getItem("access_token")
    const refreshToken: any = localStorage.getItem("refresh_token")
    const username: any = localStorage.getItem("username")
    const firstName: any = localStorage.getItem("firstName")
    const lastName: any = localStorage.getItem("lastName")
    const featureFlag: any = localStorage.getItem("feature-flag")
    const announcements: any = localStorage.getItem("announcements")
    const loginTimeStr: any = localStorage.getItem("loginTime")


    //=======
    const permission: any = JSON.parse(permissionStr);

    const loginDate: any = localStorage.getItem("loginTime");
    const loginTime = new Date(loginDate);
    const currentTime = new Date();

    const timeDifference = currentTime.getTime() - loginTime?.getTime();
    const loggedtime = timeDifference / (1000 * 60)

    const deleteConversationByC_id = async (body: deleteCoversationType) => {
        try {
            const { result, error } = await deleteCoversation(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleSignout = async () => {
        const refreshToken = localStorage.getItem("refresh_token");
        try {
            const { result, error } = await logout(refreshToken)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            if (localStorage.getItem("conversation_id") !== null) {
                const body = {
                    client_env: localStorage.getItem("clientName"),
                    user_name: localStorage.getItem("username"),
                    conv_id: localStorage.getItem("conversation_id"),
                    source_name: localStorage.getItem("source_name")
                }
                deleteConversationByC_id(body)
            }
            // toast.success(result.message, {
            //     style: {
            //         backgroundColor: '#F1F1F1', // Grey background
            //     }
            // });
            // localStorage.clear();
            localStorage.removeItem('access_token');
            localStorage.removeItem('announcements');
            //localStorage.removeItem('clientName');
            localStorage.removeItem('default_label');
            localStorage.removeItem('default_questions');
            localStorage.removeItem('feature-flag');
            localStorage.removeItem('firstName');
            localStorage.removeItem('isLogged');
            localStorage.removeItem('lastActivity');
            localStorage.removeItem('lastName');
            localStorage.removeItem('loginTime');
            localStorage.removeItem('logos');
            localStorage.removeItem('permissions');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('username');
            localStorage.removeItem('lastBotQuestion');
            localStorage.removeItem('botId');
            localStorage.removeItem("wrongAttempt");
            localStorage.removeItem("attempt");
            localStorage.removeItem('handler_name_exist');
            localStorage.removeItem("false_attempt");
            localStorage.removeItem("user_name_attempts")
            localStorage.removeItem("chatUserName");
            localStorage.removeItem("chat_access_token");
            dispatch(handleActive(""));
            dispatch(resetQuestion())
            if (localStorage.getItem('clientName') !== 'Amspec_clone') {
                navigate("/login")
            } else {
                navigate("/login?env=AmSpec")
            }
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
        // navigate("/login")
        // toast.success("Logout successfully");
        // sessionStorage.clear();
    }

    const handleDeleteIconClicked = (date: string, index: number, id: string) => {
        setDelId(id);
        const updatedIsDeleteClicked: (boolean | undefined)[] = [...isDeleteClicked];
        updatedIsDeleteClicked[index] = true;
        setIsDeleteClicked(updatedIsDeleteClicked);
        setDeleteConfirmation({ date, index });
    };

    const getConversations = async () => {
        try {
            const { result, error } = await getConversationsList();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            let sortedConversations: any;
            sortedConversations = result.items.sort((a: any, b: any) => {
                const dateA: any = moment(a.update_time);
                const dateB: any = moment(b.update_time);
                return dateB - dateA;
            });
            // Group conversations by date
            const conversationsByDate: any = {};
            sortedConversations.forEach((conversation: any) => {
                const date = moment(conversation.update_time).format(
                    'YYYY-MM-DD'
                );
                if (!conversationsByDate[date]) {
                    conversationsByDate[date] = [];
                }
                conversationsByDate[date].push(conversation);
            });
            // Organize conversations into different phases
            const today = moment().format('YYYY-MM-DD');
            const yesterday = moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
            const previous7Days = moment()
                .subtract(7, 'days')
                .format('YYYY-MM-DD');
            const previous30Days = moment()
                .subtract(30, 'days')
                .format('YYYY-MM-DD');

            const organizedData: any = {};

            // Add conversations for "Today"
            organizedData['Today'] = conversationsByDate[today] || [];

            // Add conversations for "Yesterday"
            organizedData['Yesterday'] =
                conversationsByDate[yesterday] || [];

            // Add conversations for "Previous 7 days" excluding conversations in "Today" and "Yesterday"
            organizedData['Previous 7 days'] = Object.keys(
                conversationsByDate
            )
                .filter((date) =>
                    moment(date).isBetween(
                        previous7Days,
                        yesterday,
                        null,
                        '[]'
                    )
                )
                .map((date) => conversationsByDate[date])
                .flat()
                .filter((conversation) => {
                    const conversationDate = moment(
                        conversation.update_time
                    ).format('YYYY-MM-DD');
                    return (
                        conversationDate !== today &&
                        conversationDate !== yesterday
                    );
                });

            // Add conversations for "Previous 30 days" excluding conversations in "Previous 7 days"
            organizedData['Previous 30 days'] = Object.keys(
                conversationsByDate
            )
                .filter((date) =>
                    moment(date).isBetween(
                        previous30Days,
                        previous7Days,
                        null,
                        '[]'
                    )
                )
                .map((date) => conversationsByDate[date])
                .flat()
                .filter(
                    (conversation) =>
                        moment(conversation.update_time).format(
                            'YYYY-MM-DD'
                        ) !== today &&
                        moment(conversation.update_time).format(
                            'YYYY-MM-DD'
                        ) !== yesterday
                );

            // Organize conversations by month, excluding the current month
            const conversationsByMonth: any = {};
            sortedConversations.forEach((conversation: any) => {
                const month = moment(conversation.update_time).format(
                    'MMMM YYYY'
                );
                if (month !== moment().format('MMMM YYYY')) {
                    if (!conversationsByMonth[month]) {
                        conversationsByMonth[month] = [];
                    }
                    conversationsByMonth[month].push(conversation);
                }
            });

            // Add conversations by month to the organized data
            for (const month in conversationsByMonth) {
                organizedData[month] = conversationsByMonth[month];
            }
            setData(organizedData);
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    };

    const handleGetConversation = async (id: string, username: string) => {
        const synth = window.speechSynthesis;
        if (synth.speaking) {
            synth.cancel();
            dispatch(setStopId(''));
        }
        const startTime = performance.now(); // Start the timer
        dispatch(handleLoader(true));
        dispatch(setHistoryCalled(true));
        try {
            setUserQuery([]);
            setAnswer([]);
            setCurrent(id);
            const { result, error } = await getUploadedDoc(id, username);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            const endTime = performance.now(); // End the timer
            const elapsedTime = endTime - startTime; // Calculate elapsed time
            let chatAns: any = [];
            let chatQue: any = [];
            result?.message.forEach((data: any) => {
                let newQuery = {
                    que: data.question?.content?.parts[0],
                    isUser: true,
                };
                chatQue.push(newQuery);
                let obj = {
                    ans: {
                        response: {
                            output_text: data.answer?.content?.parts.join("\n")
                        },
                        id: data.answer?.id,
                        rating: data.answer?.content?.rating,
                        created_time: data.answer?.content?.created_at,
                        feedback: data.answer?.content?.feedback_text,
                        source_info: data.answer?.content?.source_info,
                        response_time: elapsedTime.toFixed(2)
                    },
                };


                chatAns.push(obj);
            });
            dispatch(conversationDeleted(false));
            setAnswer(chatAns);
            setUserQuery(chatQue);
            dispatch(handleLoader(false));
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            if (error === 'This conversation has been deleted') {
                dispatch(conversationDeleted(true));
            }
            dispatch(handleLoader(false));
        }
    };
    const getPDFLanguage = async (body: object) => {
        try {
            const { result, error } = await getLanguage(body)
            if (error) {
                throw error;
            }
            if (result?.error) {
                throw result.error;
            }
            dispatch(handleLoader(false));
            return result;
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
            dispatch(handleLoader(false));
        }
    }
    const convertPdfToBase64 = async (url: string, setBase64Current: Dispatch<SetStateAction<string>>) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64Current(reader?.result as any);
            };
            reader.readAsDataURL(blob);
        } catch (error) {
            console.error('Error converting PDF to Base64:', error);
        }
    };
    const getBase64 = (url: string): Promise<string> => {
        return new Promise<string>((resolve) => {
            const setBase64Temp = (base64String: any) => {
                const cleanedBase64 = base64String.replace("data:application/pdf;base64,", "");
                resolve(cleanedBase64);
            };
            convertPdfToBase64(url, setBase64Temp);
        });
    };
    const handleGetConversation_2 = async (id: string, username: string) => {
        dispatch(handleLoader(true));
        dispatch(setHistoryCalled(true));
        setShowShare(false)
        dispatch(handleDocuMatePDF({}));
        setActiveIndex(0)
        // setShowModal(true)
        try {
            setUserQuery([]);
            dispatch(handleDocuMateUserQuery([]))
            setAnswer([]);
            setCurrent(id);
            setInputFileName("")
            setBase64("");
            setFileLanguage("")
            setFileCompLanguage("")
            setFileSynthLanguage("")
            setComparisonDocFile("")
            setSynthesizeDocFile("")
            setComparisonDocName("")
            setSynthesizeDocName("")
            const { result, error } = await getUploadedDoc(id, username);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            const body = {
                query: "",
                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                file_data: result?.message[0]?.question?.file_data,
                file_name: result.message[0]?.question.file_name
            }
            if (result?.message) {
                let hasSynthOrComp = false;

                // Loop through the array to check for Synthesization or Comparison
                result?.message.forEach((result: any) => {
                    const questionType = result.question?.content?.parts[0];
                    if (questionType === 'Synthesization' || questionType === 'Comparison') {
                        hasSynthOrComp = true;  // Flag if either Synthesization or Comparison exists
                    }
                });

                // If Synthesization or Comparison exists
                if (hasSynthOrComp) {
                    result?.message.forEach(async (result: any) => {
                        const questionType = result.question?.content?.parts[0];

                        if (questionType === 'Comparison') {
                            let cleanedFileData = result?.question?.file_data.replace(/\/Ron_Project/g, '');
                            let fileNamesArray = result?.question?.file_name.split('|');
                            let fileDataArray = cleanedFileData.split('|');

                            const getCorrectFileName = (fileName: string) => {
                                const splitName = fileName.split('___');
                                return `${splitName[0]}.pdf`;
                            };

                            let combinedFiles = fileNamesArray.map((name: string, index: number) => {
                                return {
                                    fileName: getCorrectFileName(name),
                                    filePath: fileDataArray[index],
                                };
                            });

                            const base64File1 = await getBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`);
                            let body1 = {
                                query: "",
                                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                                file_data: base64File1,
                                file_name: combinedFiles[0]?.fileName,
                            };

                            const result1 = await getPDFLanguage(body1);
                            if (result1 && result1.PDF_Language) {
                                setFileLanguage(result1.PDF_Language);
                            } else {
                                console.error("No language detected for the first PDF");
                            }

                            const base64File2 = await getBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`);
                            let body2 = {
                                query: "",
                                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                                file_data: base64File2,
                                file_name: combinedFiles[1]?.fileName,
                            };

                            const result2 = await getPDFLanguage(body2);
                            if (result2 && result2.PDF_Language) {
                                setFileCompLanguage(result2.PDF_Language);
                            } else {
                                console.error("No language detected for the second PDF");
                            }
                        } else if (questionType === 'Synthesization') {
                            let cleanedFileData = result?.question?.file_data.replace(/\/Ron_Project/g, '');
                            let fileNamesArray = result?.question?.file_name.split('|');
                            let fileDataArray = cleanedFileData.split('|');

                            const getCorrectFileName = (fileName: string) => {
                                const splitName = fileName.split('___');
                                return `${splitName[0]}.pdf`;
                            };

                            let combinedFiles = fileNamesArray.map((name: string, index: number) => {
                                return {
                                    fileName: getCorrectFileName(name),
                                    filePath: fileDataArray[index],
                                };
                            });

                            const base64File3 = await getBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`);
                            let body1 = {
                                query: "",
                                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                                file_data: base64File3,
                                file_name: combinedFiles[0]?.fileName,
                            };

                            const result3 = await getPDFLanguage(body1);
                            if (result3 && result3.PDF_Language) {
                                setFileLanguage(result3.PDF_Language);
                            } else {
                                console.error("No language detected for the first PDF");
                            }

                            const base64File4 = await getBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`);
                            let body2 = {
                                query: "",
                                user_name: localStorage.getItem('username') ?? 'meet.patel@rysun.com',
                                file_data: base64File4,
                                file_name: combinedFiles[1]?.fileName,
                            };

                            const result4 = await getPDFLanguage(body2);
                            if (result4 && result4.PDF_Language) {
                                setFileSynthLanguage(result4.PDF_Language);
                            } else {
                                console.error("No language detected for the second PDF");
                            }
                        }
                    });
                }
                // If no Synthesization or Comparison exists, enter else condition
                else {
                    if (body?.file_data) {
                        const result3 = await getPDFLanguage(body);
                        if (result3 && result3.PDF_Language) {
                            setFileLanguage(result3.PDF_Language);
                        } else {
                            console.error("No language detected for the second PDF");
                        }
                    }
                    dispatch(handleLoader(false));
                }
            } else {
                dispatch(handleLoader(false));
            }
            let chatAns: any = [];
            let chatQue: any = [];
            setBase64(result?.message[0]?.question?.file_data);
            setInputFileName(result.message[0]?.question.file_name)
            result?.message.forEach(async (data: any) => {
                let newQuery = {
                    que: data.question?.content?.parts[0],
                    isUser: true,
                    pdfFile: data?.question?.file_data,
                    pdfName: data?.question?.file_name
                };
                chatQue.push(newQuery);
                let obj = {
                    ans: {
                        response: {
                            output_text: data.answer?.content?.parts.join("\n"),
                        },
                        id: data.answer?.id,
                        rating: data.answer?.content?.rating,
                        created_time: data.answer?.content?.created_at,
                        feedback: data.answer?.content?.feedback_text,
                        source_info: data.answer?.content?.source_info
                    },
                };
                chatAns.push(obj);
                // Check if the question is 'Synthesization' or 'Comparison'
                const questionType = data.question?.content?.parts[0];

                if (['Synthesization', 'Comparison'].includes(questionType)) {
                    let cleanedFileData = data?.question?.file_data.replace(/\/Ron_Project/g, '');
                    let fileNamesArray = data?.question?.file_name.split('|');
                    let fileDataArray = cleanedFileData.split('|');

                    const getCorrectFileName = (fileName: string) => {
                        const splitName = fileName.split('___');
                        return `${splitName[0]}.pdf`;
                    };

                    let combinedFiles = fileNamesArray.map((name: string, index: number) => {
                        return {
                            fileName: getCorrectFileName(name),
                            filePath: fileDataArray[index]
                        };
                    });

                    if (questionType === 'Comparison') {
                        // Set data for comparison
                        setInputFileName(combinedFiles[0]?.fileName);
                        // setBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`);
                        setComparisonDocName(combinedFiles[1]?.fileName);
                        await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`, setBase64)
                        await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`, setComparisonDocFile)
                        // setComparisonDocFile(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`);
                        // newQuery.pdfFile = comparisonDocFile;
                    } else if (questionType === 'Synthesization') {
                        // Set data for synthesization
                        setInputFileName(combinedFiles[0]?.fileName);
                        await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`, setBase64)
                        await convertPdfToBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`, setSynthesizeDocFile)
                        // setBase64(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[0]?.filePath)}`);
                        setSynthesizeDocName(combinedFiles[1]?.fileName);
                        // newQuery.pdfFile = synthesizeDocFile;
                        // setSynthesizeDocFile(`${process.env.REACT_APP_DOC_PROCESSING_PDF}${encodeURIComponent(combinedFiles[1]?.filePath)}`);
                    }
                }

            });
            setAnswer(chatAns);
            setUserQuery(chatQue);
            dispatch(handleDocuMateUserQuery(chatQue))
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        }
    };
    const handleNewChatButton = () => {
        dispatch(handleDocuMateUserQuery([]))
        dispatch(handleDocuMateCounter(false));
        setBase64("");
        setFileLanguage("");
        setFileSynthLanguage("");
        setFileCompLanguage("");
        setComparisonDocFile("")
        setSynthesizeDocFile("")
        setShowShare(false)
        setShowModal(false)
        setShowModalCompare(false)
        setShowModalSynthesize(false)
        setInputFileName("")
        setModalOption("")
        setModalOptionCompare("")
        setModalOptionSynthesize("")
        const newQuery = {
            que: "",
            isUser: true,
        };
        setUserQuery([newQuery]);
        const newAns: Answer = {
            ans: {
                isFirst: true,
                response: {
                    output_text: "",
                },
                id: '',
                created_time: '',
                feedback: '',
                source_info: [],
                csv_file: '',
                file_flag: false,
                file_type: '',
                response_time: '',
            },
        };
        setAnswer([newAns]);
        dispatch(handleQMateCounter(false))
    };
    const handleDelete = async (date: any, index: any) => {
        try {
            const { result, error } = await deleteConversation(delId);
            if (error) {
                throw error
            }
            if (result?.error) {
                const updatedIsDeleteClicked: any = [...isDeleteClicked];
                updatedIsDeleteClicked[index] = false;
                setIsDeleteClicked(updatedIsDeleteClicked);
                throw result.error
            }
            toast.success('Conversation deleted successfully', {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
            if (delId === paramsId) {
                handleNewChatButton();
                setHover(null);
                setCurrent(null);
                navigate(`/home`);
                if (currentActive === 'documate') {
                    dispatch(handleDocuMatePDF({}));
                    setBase64("");
                    setComparisonDocFile("")
                    setSynthesizeDocFile("")
                    dispatch(handleActive("documate"))
                } else if (currentActive === "qmate") {
                    dispatch(handleActive("qmate"))
                }

            }
            const updatedIsDeleteClicked: any = [...isDeleteClicked];
            updatedIsDeleteClicked[index] = false;
            setIsDeleteClicked(updatedIsDeleteClicked);
            getConversations();

        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    };

    /* if(permissionStr == null || accessToken== null || refreshToken == null || username == null || firstName == null || lastName == null || featureFlag == null || announcements == null || loginTimeStr == null){
        handleSignout()
    } */
    useEffect(() => {
        let activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll'];

        const setLastActivity = () => {
            localStorage.setItem('lastActivity', String(Date.now()));
        };

        const activityListener = () => {
            setLastActivity();
        };

        activityEvents.forEach((event) => {
            document.addEventListener(event, activityListener);
        });


        // document.addEventListener('mousemove', activityListener);
        // document.addEventListener('click', activityListener);

        const interval = setInterval(() => {
            const lastActivity = localStorage.getItem('lastActivity');
            if (lastActivity) {
                const diffMs = Math.abs(Date.now() - parseInt(lastActivity));
                const seconds = Math.floor(diffMs / 1000);
                const minutes = Math.floor(seconds / 60);
                if (minutes >= 30) {
                    handleSignout()
                    clearInterval(interval);
                }
            }
        }, 1000);

        return () => {
            //   document.removeEventListener('click', activityListener);
            activityEvents.forEach((event) => {
                document.removeEventListener(event, activityListener);
            });
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        const sidebar = document.getElementById('wrapper');
        const appElement = document.querySelector('.app');

        const handleSidebarHover = () => {
            if (sidebar && sidebar.classList.contains('sidebar--open')) {
                appElement && appElement.classList.add('position-fixed');
            }
        };

        const handleSidebarLeave = () => {
            appElement && appElement.classList.remove('position-fixed');
        };

        sidebar && sidebar.addEventListener('mouseover', handleSidebarHover);
        sidebar && sidebar.addEventListener('mouseleave', handleSidebarLeave);

        return () => {
            sidebar && sidebar.removeEventListener('mouseover', handleSidebarHover);
            sidebar && sidebar.removeEventListener('mouseleave', handleSidebarLeave);
        };
    }, []);


    useEffect(() => {
        if (refreshToken == null) {
            // localStorage.clear();
            localStorage.removeItem('access_token');
            localStorage.removeItem('announcements');
            //localStorage.removeItem('clientName');
            localStorage.removeItem('default_label');
            localStorage.removeItem('default_questions');
            localStorage.removeItem('feature-flag');
            localStorage.removeItem('firstName');
            localStorage.removeItem('isLogged');
            localStorage.removeItem('lastActivity');
            localStorage.removeItem('lastName');
            localStorage.removeItem('loginTime');
            localStorage.removeItem('logos');
            localStorage.removeItem('permissions');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('username');
            localStorage.removeItem('lastBotQuestion');
            localStorage.removeItem('botId');
            if (localStorage.getItem('clientName') === 'Amspec_clone') {
                navigate("/login?env=AmSpec")
            } else {
                navigate("/login")
            }
        }
        if (refreshToken !== null && (loggedtime >= LOGOUT_TIME_MIN || permissionStr == null || accessToken == null || username == null || firstName == null || lastName == null || featureFlag == null || announcements == null || loginTimeStr == null)) {
            handleSignout();
        }
        // getConversations();
    }, [])
    permission?.forEach((element: any) => {
        routes.push({
            path: "/home",
            element: <Home overlayLens={overlayLens} oh={oh} />
        });
        if (localStorage.getItem("clientName") !== 'Veedalifescience') {
            routes.push(
                {
                    path: "/user-dashboard",
                    element: <UserDashboard />,
                },
            )
        }
        if (element.key === PERMISSION_KEY.user && element.permissions.view) {
            dispatch(handleUserPermission(element.permissions));
            routes.push({
                path: "/admin/users",
                children: [
                    {
                        index: true,
                        element: <Users />
                    }, {
                        path: ':id',
                        element: <AddUpdateUser />
                    }
                ]
            });

        }
        else if (element.key === PERMISSION_KEY.role && element.permissions.view) {
            dispatch(handleRolePermission(element.permissions));
            routes.push({
                path: "/admin/roles",
                children: [
                    {
                        index: true,
                        element: <RoleManagement />
                    }, {
                        path: ':id',
                        element: <AddRole />
                    }
                ]
            });

        }
        else if (element.key === PERMISSION_KEY.group && element.permissions.view) {
            dispatch(handleGroupPermission(element.permissions));
            routes.push({
                path: "/admin/groups",
                children: [
                    {
                        index: true,
                        element: <Group />
                    }, {
                        path: ':id',
                        element: <AddUpdateGroup />
                    }
                ]
            });

        }
        else if (element.key === PERMISSION_KEY.announcements && element.permissions.view) {
            dispatch(handleAnnouncementPermission(element.permissions));
            routes.push(
                {
                    path: "/admin/announcements",
                    children: [
                        {
                            index: true,
                            element: <Notification />
                        },
                    ],

                },
            );

        }
        else if (element.key === PERMISSION_KEY.dashboard && element.permissions) {
            routes.push({
                path: "/admin/dashboard",
                element: <Dashboard />,
            });
        }
        else if (element.key === PERMISSION_KEY.conversationHistory && element.permissions) {
            routes.push({
                path: "/admin/conversation-history",
                element: <ConversationHistory />
            });
        }
        else if (element.key === PERMISSION_KEY.flagSettings && element.permissions) {
            routes.push({
                path: "/admin/flag-settings",
                element: <FlagSettings />,
            });
        }
        else if (element.key === PERMISSION_KEY.docApproval && element.permissions) {
            routes.push({
                path: "/admin/doc-approval",
                element: <DocumentApproval />,
            });
        }
        else if (element.key === PERMISSION_KEY.permissions && element.permissions) {
            routes.push({
                path: "/admin/permission",
                element: <Permission />,
            });
        }
        // else if (element.key === PERMISSION_KEY.bot && element.permissions) {
        //     routes.push({
        //         path: "/bot",
        //         element: <ChatBot />,
        //     });
        // }
        // else if (element.key === PERMISSION_KEY.lens && element.permissions) {
        //     routes.push({
        //         path: "/lens/similar-image",
        //         element: <ProcessImage />,
        //     });
        // }
        else if (element.key === PERMISSION_KEY.configuration && element.permissions) {
            routes.push({
                path: "/admin/configuration",
                element: <ParamConfiguration />,
            });
        }
        else if (element.key === PERMISSION_KEY.bot_configuration && element.permissions) {
            routes.push({
                path: "/admin/bot-configuration",
                element: <BotConfiguration />,
            });

        }
        else if (element.key === PERMISSION_KEY.inventoryForecastConfiguration && element.permissions) {
            routes.push({
                path: "/admin/inventory-forecast-configuration",
                element: <InventoryForecastConfiguration />,
            });
        }
        else if (element.key === PERMISSION_KEY.imageExtender && element.permissions) {
            routes.push({
                path: "/lens/image-extender",
                element: <ImageExpansion />,
            });
        }
        else if (element.key === PERMISSION_KEY.similarImages && element.permissions) {
            routes.push({
                path: "/lens/similar-image",
                element: <ProcessImage />,
            });
        }
        else if (element.key === PERMISSION_KEY.smartBackground && element.permissions) {
            routes.push({
                path: "/lens/smart-background",
                element: <SmartBackground />,
            });
        }
        else if (element.key === PERMISSION_KEY.generateInstance && element.permissions) {
            routes.push({
                path: "/lens/generate-instance",
                element: <GenerateInstance />,
            });
        }
        else if (element.key === PERMISSION_KEY.imageComparison && element.permissions) {
            routes.push({
                path: "/lens/image-comparison",
                element: <CompareImage />,
            });
        }
        else if (element.key === PERMISSION_KEY.articleGeneration && element.permissions) {
            routes.push({
                path: "/generate-article",
                children: [
                    {
                        index: true,
                        element: <GenerateArtical />,
                    },
                    {
                        path: ":id",
                        element: <GenerateArtical />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.emailGeneration && element.permissions) {
            routes.push({
                path: "/generate-email",
                children: [
                    {
                        index: true,
                        element: <GenerateEmail />,
                    },
                    {
                        path: ":id",
                        element: <GenerateEmail />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.ideaGeneration && element.permissions) {
            routes.push({
                path: "/generate-idea",
                children: [
                    {
                        index: true,
                        element: <GenerateIdea />,
                    },
                    {
                        path: ":id",
                        element: <GenerateIdea />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.postGeneration && element.permissions) {
            routes.push({
                path: "/generate-post",
                children: [
                    {
                        index: true,
                        element: <GeneratePost />,
                    },
                    {
                        path: ":id",
                        element: <GeneratePost />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.productDesGeneration && element.permissions) {
            routes.push({
                path: "/generate-product",
                children: [
                    {
                        index: true,
                        element: <GenerateProduct />,
                    },
                    {
                        path: ":id",
                        element: <GenerateProduct />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.sentimentAnalysis && element.permissions) {
            routes.push({
                path: "/sentiment-analysis",
                children: [
                    {
                        index: true,
                        element: <SentimentAnalysis />,
                    },
                    {
                        path: ":id",
                        element: <SentimentAnalysis />,
                    },
                ],
            });

        }
        else if (element.key === PERMISSION_KEY.uploadDoc && element.permissions) {
            routes.push({
                path: "/document-processing",
                children: [
                    {
                        index: true,
                        element: <DocumentProcessing />,
                    },
                    {
                        path: ":id",
                        element: <DocumentProcessing />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.q_a && element.permissions) {
            routes.push({
                path: "/chat-bot",
                children: [
                    {
                        index: true,
                        element: <AiChatbot />,
                    },
                    {
                        path: ":id",
                        element: <AiChatbot />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.voice && element.permissions) {
            routes.push({
                path: "/voice",
                children: [
                    {
                        index: true,
                        element: <VoiceHistory />,
                    },
                    {
                        path: ":id",
                        element: <VoiceInteraction />,
                    },
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.black_listed_word && element.permissions) {
            routes.push({
                path: "/admin/black-listed-words",
                children: [
                    {
                        index: true,
                        // path: ':id',
                        element: <BlackListedWords />,
                    },
                    {
                        // index: true,
                        path: ':id',
                        element: <AddBlackListWord />
                    }
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.scrapper && element.permissions) {
            routes.push({
                path: "/admin/web-scrapper",
                children: [
                    {
                        // index: true,
                        path: ':id',
                        element: <WebScrapper />,
                    },
                    {
                        index: true,
                        // path: 'history',
                        element: <History />
                    }
                ],
            });
        }
        else if (element.key === PERMISSION_KEY.sftp && element.permissions) {
            routes.push({
                path: "/admin/pdf-upload",
                children: [
                    {
                        index: true,
                        element: <PdfUpload />,
                    },
                    {
                        path: "/admin/pdf-upload/file-config",
                        element: <FileConfig />,
                    },
                ]
            });
        }
    });
    let element = useRoutes(tempRoutes);

    // useEffect(() => {
    //     window.addEventListener("resize", () => {
    //         window.innerWidth >= 768 && window.innerWidth <= 991 ? setMenuToggle(true) : setMenuToggle(false)
    //     });
    //     document.addEventListener("mousedown", handleClickOutside);

    //     return () => {
    //         window.removeEventListener("resize", () => {
    //             window.innerWidth >= 768 && window.innerWidth <= 991 ? setMenuToggle(true) : setMenuToggle(false)
    //         });
    //         document.addEventListener("mousedown", handleClickOutside);

    //     };
    // }, []);


    const handleMenuClick = () => {
        setMenuToggle(!menuToggle)
    }
    // Check if the key exists in session storage
    const isKeyInlocalStorage = () => {
        return localStorage.getItem("access_token") === null;
    };
    if (localStorage.getItem("access_token") === null) {
        toast.success("Logged out successfully", {
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }
        });
        dispatch(resetQuestion())
        if (localStorage.getItem('clientName') === 'Amspec_clone') {
            navigate("/login?env=AmSpec")
        } else {
            navigate("/login")
        }
    }
    const iframeRef: any = useRef<HTMLIFrameElement>(null);
    const [sharedValue, setSharedValue] = useState<string | null>(null);
    useEffect(() => {
        const handleBeforeUnload = () => {
            dispatch(handleChatclose(false))
        };

        window.addEventListener("popstate", handleBeforeUnload);

        return () => {
            window.removeEventListener("popstate", handleBeforeUnload);
        };
    }, []);
    // console.log("sharedValue", sharedValue)
    const [isShowButton, setIsShowButton] = useState<boolean>(false);
    useEffect(() => {
        const temp = document.getElementById('home');
        if (chatBotPreview && temp) {
            temp.classList.add("blur-bot");
        } else {
            if (temp) {
                temp.classList.remove('blur-bot')
            }
        }
    }, [chatBotPreview])
    return (
        <div className={`home-main`} id="home" onClick={() => { overlayLens?.current?.hide(); oh?.current?.hide(); }}>
            <div className='home-wrap'>
                {/* {window.location.pathname !== "/home"
                &&
                <Header handleMenuClick={handleMenuClick} logoRef={logoRef} />
            } */}
                <HeaderOne oh={oh} overlayLens={overlayLens} />
                {temp[0] === 'admin' && !notFound
                    &&
                    <Sidebar oh={oh} isActive={isActive} setActive={setActive} sidebarRef={sidebarRef} />
                }
                <div className={`${temp[0] === 'admin' && !notFound ? "admin-body-wrap" : ""}  ${isActive ? "sidebar-sm-active" : ""}`}>
                    <StateContext.Provider value={{ handleGetConversation_2, showModalSynthesize, setShowModalSynthesize, showModalCompare, setShowModalCompare, modalOptionSynthesize, setModalOptionSynthesize, modalOption, setModalOption, modalOptionCompare, setModalOptionCompare, base64, setBase64, comparisonDocName, setComparisonDocName, synthesizeDocName, setSynthesizeDocName, showShare, setShowShare, comparisonDocFile, setComparisonDocFile, setFileSynthLanguage, fileSynthLanguage, setFileCompLanguage, fileCompLanguage, setFileLanguage, fileLanguage, setActiveIndex, activeIndex, inputfilename, synthesizeDocFile, setSynthesizeDocFile, data, setData, deleteConfirmation, setDeleteConfirmation, current, setCurrent, hover, setHover, showEditDelete, setShowEditDelete, isDeleteClicked, setIsDeleteClicked, delId, setDelId, userQuery, setUserQuery, answer, setAnswer, handleNewChatButton, getConversations, handleGetConversation, handleDelete, setParamsId }}>
                        {element}
                    </StateContext.Provider>
                    {/* <div className="iframe-container">
                        <div className="chat-bot-section">
                            {!isShowButton && <p>How may I help you today?</p>}
                            <button type='button' className={`chat-bot-button ${isShowButton && "comments"}`} onClick={() => setIsShowButton(!isShowButton)}>
                                {isShowButton ? <i className="pi pi-times" style={{ fontSize: "22px" }}></i>
                                    : <i><img src={chatBotWhite} alt='chat-bot-icon' /></i>}
                            </button>
                        </div>
                        {isShowButton &&
                            <iframe
                                ref={iframeRef}
                                id="child-iframe"
                                // allowtransparency={true}
                                style={{
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    position: 'fixed', float: 'right', bottom: '1px', right: '1px'
                                }}
                                allow="allow-scripts"
                                sandbox="allow-scripts allow-same-origin"
                                // src="http://localhost:8020/"
                                src="http://10.1.1.77:5008/"
                                width="450"
                                height="550"
                                loading="lazy"
                            ></iframe>
                        }
                    </div> */}
                    {temp[0] !== 'admin' && ['home', 'chat-bot', 'document-processing'].includes(temp[0]) && (currentActive === 'documate' || currentActive === 'qmate') && (HistoryFlag === true || HistoryFlag === undefined) &&
                        <>
                            <Button label="Chat History" outlined icon="pi pi-history" className='outline-icon-btn chat-history-btn' onClick={() => setVisibleRight(true)} />
                            <ConversationList
                                current={current}
                                setCurrent={setCurrent}
                                handleGetConversation={handleGetConversation}
                                handleGetConversation_2={handleGetConversation_2}
                                data={data}
                                setVisibleRight={setVisibleRight}
                                visibleRight={visibleRight}
                                setData={setData}
                                hover={hover}
                                showEditDelete={showEditDelete}
                                setShowEditDelete={setShowEditDelete}
                                setHover={setHover}
                                handleDeleteIconClicked={handleDeleteIconClicked}
                                component={currentActive === 'documate' ? 'document-processing' : "chat-bot"}
                                source_name={"chat-bot"}
                                emailData={emailData}
                                setEmailData={setEmailData}
                                getConversations={getConversations}
                            />
                            {/* <ConversationList
                                current={current}
                                setCurrent={setCurrent}
                                handleGetConversation={handleGetConversation}
                                data={data}
                                setVisibleRight={setVisibleRight}
                                visibleRight={visibleRight}
                                setData={setData}
                                hover={hover}
                                showEditDelete={showEditDelete}
                                setShowEditDelete={setShowEditDelete}
                                setHover={setHover}
                                getConversations={getConversations}
                                handleDelete={handleDelete}
                                handleDeleteIconClicked={handleDeleteIconClicked}
                                emailData={emailData}
                                setEmailData={setEmailData}
                                component={"generate-article"}
                                source_name={"article_generation"}
                            /> */}
                        </>
                    }
                    <Modal
                        date={deleteConfirmation?.date}
                        index={deleteConfirmation?.index}
                        handleDelete={handleDelete}
                        onCancel={() => {

                            const updatedIsDeleteClicked = [...isDeleteClicked];

                            updatedIsDeleteClicked[
                                deleteConfirmation.index
                            ] = false;

                            setIsDeleteClicked(updatedIsDeleteClicked);

                        }}
                        promptText={promptText}
                    />
                </div>
                {loader && (
                    <div className="clip-loader">
                        <div className="loader-spinner"></div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Baselayout